import { JsonObject } from '../../app/json/jsonObject.js';
import { ResourceStatistics } from '../../model/resourceStatistics.js';
import type { PreprocessedTemplate } from './preprocessedTemplate.js';

export class PreProcessTemplateEntry {
    template: PreprocessedTemplate;
    json: JsonObject | null;

    constructor(template: PreprocessedTemplate, json: JsonObject | null = null) {
        this.template = template;
        this.json = json;
    }
}

type PreProcessTemplateStoreMap = Map<string, PreProcessTemplateEntry>;

export class PreProcessTemplateStore {
    private _appSiteCache: Map<string, PreProcessTemplateStoreMap> = new Map();
    private _resourceStatsCache: Map<string, ResourceStatistics> = new Map();

    hasAppSite(appSite: string): boolean {
        return this._appSiteCache.has(appSite);
    }

    tryGetTemplates(appSite: string): PreProcessTemplateStoreMap | undefined {
        if (!this._appSiteCache.has(appSite)) {
            return undefined;
        }

        return this._appSiteCache.get(appSite);
    }

    getTemplates(appSite: string): PreProcessTemplateStoreMap {
        const templates = this._appSiteCache.get(appSite);
        if (!templates) throw new Error(`Templates not loaded for AppSite: ${appSite}`);
        return templates;
    }

    addAppSite(appSite: string, templates: PreProcessTemplateStoreMap): boolean {
        if (!this._appSiteCache.has(appSite)) {
            this._appSiteCache.set(appSite, templates);
            return true;
        }
        return false;
    }

    setTemplates(appSite: string, templates: PreProcessTemplateStoreMap): void {
        this._appSiteCache.set(appSite, templates);
    }

    getAllAppSites(): Map<string, PreProcessTemplateStoreMap> {
        return this._appSiteCache;
    }

    tryGetResourceStats(appSite: string): ResourceStatistics | undefined {
        if (!this._resourceStatsCache.has(appSite)) {
            return undefined;
        }

        return this._resourceStatsCache.get(appSite);
    }

    setResourceStats(appSite: string, stats: ResourceStatistics): void {
        this._resourceStatsCache.set(appSite, stats);
    }
}
